<div class="landing-location-tile-container">
  <div
    class="oswald landing-location-tile-title-container d-flex justify-content-between align-items-center"
    [ngClass]="{'preferred': isPreferred}"
  >
    <div role="heading" aria-level="2">{{ locationData.name }}</div>
    <img
      *ngIf="isPreferred"
      src="assets/svg/ico_heart_action.svg"
      alt="Heart Icon"
      width="21"
    >
  </div>
  <div
    class="landing-location-tile-content-container"
    [ngClass]="{'preferred': isPreferred}"
  >
    <div class="landing-location-tile-address-container d-flex justify-content-between align-items-center">
      <div>
        <div class="lato bold teal">{{ locationData.address1 }}</div>
        <div
          *ngIf="locationData.address2"
          class="lato bold teal"
        >{{ locationData.address2 }}</div>
        <div class="lato">{{ locationData.city + ', ' + locationData.state + ' ' + locationData.zipcode }}</div>
      </div>
      <a
        [href]="googleMapsService.getDirectionsUrl(
          locationData.address1 + ' ' + locationData.address2 + ', ' +
          locationData.city + ', ' + locationData.state + ' ' + locationData.zipcode
        )"
        target="_blank"
      >
        <img
          src="assets/svg/ico_location_outline.svg"
          alt="Location Icon"
          width="22"
        >
      </a>
    </div>
    <hr class="divider">
    <div class="landing-location-tile-info-container row no-gutters">
      <div class="col pr-1">
        <a
          role="button"
          [href]="'tel:' + locationData.telephone"
          class="btn btn-secondary btn-block btn-height-auto d-flex justify-content-center align-items-center"
        >{{ locationData.telephone | phoneNumber }}</a>
      </div>
      <div class="col pl-1">
        <button
          class="btn btn-secondary btn-block btn-height-auto"
          (click)="viewCampDetails()"
        >Camp Details</button>
      </div>
    </div>
    <hr class="divider">
    <div class="landing-location-tile-action-container">
      <button
        class="btn btn-danger btn-block btn-height-auto"
        (click)="bookReserv()"
      >Book a Reservation</button>
      <button
        class="btn btn-outline-danger btn-block btn-height-auto"
        (click)="navigateToInterviewRequest()"
      >Request an Interview</button>
    </div>
  </div>
</div>
